import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HTTP_VERBS } from 'utils/constants';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import useApi from 'utils/hooks/api/useApi';

const useGenerateCodes = () => {
  const endpoint = `${API_ENDPOINTS.SCREENINGS}/generate-code`;
  const { showNotification } = useRoot();
  const { t } = useTranslation(LOCALIZATION_PAGES.SCREENINGS);
  const [{ result, loading, error }, generateCodes] = useApi(endpoint, {
    initialFetch: false,
    verb: HTTP_VERBS.PUT,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('generate_codes_failed_text'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('generate_codes_success_text'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading }, generateCodes];
};

export default useGenerateCodes;
